module.exports = __webpack_public_path__ + "media/images/site/insta-eb4eb4e9148a89fbd4780ef9c1cf5518.png";